import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BackButton } from '../../../components/navigation/BackButton'
import { UploaderComponent } from '../../../components/uploaders/UploaderComponent'
import { useGetProject } from '../hooks'
import { useUploadDailyReports } from './hooks'
import Uploader from '../../valueLists/Uploader'

export default function ImportDailyReports() {
    const { id } = useParams()
    const { data } = useGetProject('project', id)
    const navigate = useNavigate()
    const { mutateAsync } = useUploadDailyReports('dailyreports', id)

    const [dataSet, setDataSet] = useState<any>()
    const [showUpload, setShowUpload] = useState<any>(true)

    const handleImportData = async (dataSet: any) => {
        const uploadDR = await mutateAsync(dataSet)
        if (uploadDR) {
            navigate(`/projects/${id}`)
        }
    }

    const handleUploadData = (upload: any) => {
        setDataSet(upload.data)
        setShowUpload(false)
    }
    return (
        <>
            <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
                <Container maxWidth='lg'>
                    {data ? <>
                        <BackButton />
                        <Typography variant='h5' gutterBottom>{`${data.projectName} - Import Daily Reports`}</Typography>
                    </>
                        : null
                    }
                    {/* <UploaderComponent isImportReport={true}
                        handleImportData={handleImportData}
                    /> */}
                    <Card sx={{ marginBottom: 2, boxShadow: 'none', textAlign: 'center', border: '1px dashed #000' }}>
                        <CardContent>
                            <Button variant='contained' color='secondary' disabled onClick={handleImportData}>Browse file</Button><br />
                            Drop CSV file here or click to upload
                        </CardContent>
                    </Card>
                </Container>
            </Box>
        </>
    )
}